import React from 'react';
import { useAuth } from '@/core/auth';
import { useDashboard } from '../../hooks/useDashboard';
import { StatsGrid } from '../StatsGrid';
import { ScheduleCard } from '../ScheduleCard';
import { UrgentCard } from '../UrgentCard';
import { ReportsCard } from '../ReportsCard';
import './DashboardView.styles.css';
import '../../styles/dashboard.css';

export const DashboardView: React.FC = () => {
  const { user } = useAuth();
  const { stats, notifications, isLoading, error } = useDashboard();

  // Loading state
  if (isLoading) {
    return (
      <div className="dashboard-page">
        <div className="dashboard-loading-state">
          <div className="dashboard-loading-spinner"></div>
          <p className="dashboard-loading-text">Chargement du tableau de bord...</p>
        </div>
      </div>
    );
  }

  // Error state
  if (error) {
    return (
      <div className="dashboard-page">
        <div className="dashboard-error-state">
          <p className="dashboard-error-message">⚠️ Erreur: {(error as Error).message || 'Une erreur est survenue lors du chargement du tableau de bord.'}</p>
        </div>
      </div>
    );
  }

  return (
    <div className="dashboard-page">
      {/* Header Section - matching Planning and A-Traiter style */}
      <div className="dashboard-page__header">
        <div className="dashboard-page__header-content">
          <h1 className="dashboard-page__title">
            Tableau de bord
          </h1>
          <p className="dashboard-page__subtitle">
            Voici un aperçu de vos activités et notifications
          </p>
        </div>
      </div>

      {/* Main Content */}
      <div className="dashboard-page__content">
        {/* Stats Overview */}
        <StatsGrid stats={stats} />

        {/* Notification Cards Grid */}
        <div className="dashboard-grid">
          <ScheduleCard schedule={notifications.nextDay} />
          <UrgentCard urgentDossiers={notifications.urgentDossiers} />
          <ReportsCard pendingReports={notifications.pendingReports} />
        </div>
      </div>
    </div>
  );
};